module.exports = __webpack_public_path__ + "static/media/2_The inner voice_IN.8cac7e52.txt";